module.exports = __webpack_public_path__ + "static/img/3330_phase_function_Paper_Points.8def6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3330_phase_function_Paper_Points.png
// module id = ItGo
// module chunks = 0